<template>
  <v-container fluid>
    <v-card>
      <v-card-title class="mb-n4">
        Время на линии
      </v-card-title>
      <!-- selectors -->
      <v-form ref="form" class="mb-n1">
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <div class="mt-4">
                <CaruselButton
                  ref="month_selector"
                  v-if="caruselOptions.length"
                  label="Месяц"
                  type="general"
                  :items="caruselOptions"
                  :getVal="getDate"
                />
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <GroupSelector noRules v-model="groups" @change:users="fillAgents"/>
            </v-col>

            <v-col cols="12" sm="6" md="3">
              <UserSelector v-model="agents" />
            </v-col>

            <v-col cols="12" sm="6" md="2" align="right">
              <v-btn
                class="mt-4"
                color="success"
                @click="loadReport"
              >
                Поиск
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
    </v-card>


    <v-card class="mt-5 py-3">
      <!-- Переключалка время рабоы/разговора/занятость -->
      <v-container fluid>
        <v-row class="pr-4">
          <v-col cols="auto">
            <v-btn-toggle
              v-model="btnSwitch"
              mandatory
              rounded
              dense
            >
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-btn v-on="on">
                    <v-icon>mdi-clock</v-icon>
                  </v-btn>
                </template>
                <span>Время работы</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-btn v-on="on">
                    <v-icon>mdi-forum</v-icon>
                  </v-btn>
                </template>
                <span>Время разговора</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-btn v-on="on">
                    <v-icon>mdi-account-voice</v-icon>
                  </v-btn>
                </template>
                <span>Загрузка</span>
              </v-tooltip>
            </v-btn-toggle>
          </v-col>

          <v-col cols="2">
            <v-switch
              v-model="onlyActive"
              dense
              inset
              color="info"
              class="mt-auto"
              label="Скрыть неактивных"
            ></v-switch>
          </v-col>

          <v-col cols="2">
            <v-switch
              v-model="hideBlocked"
              dense
              inset
              color="info"
              class="mt-auto"
              label="Скрыть заблокированных"
            ></v-switch>
          </v-col>

          <v-tooltip v-if="showAutoFill" bottom max-width="400">
            <template #activator="{ on }">
              <v-btn v-on="on" icon class="mt-2" @click="fillNextMonth">
                <v-icon color="info">mdi-reload</v-icon>
              </v-btn>
            </template>
            <span>Продлить расписание</span>
          </v-tooltip>


          <!-- Бейджики -->
          <v-badge
            v-if="'total_avg' in report"
            class="ml-5 my-2"
            bordered
            color="info"
            overlap
            ><v-chip
                color="info"
                label
                outlined
            >Операторов
            </v-chip>
            <template v-slot:badge>
              <span>{{actualReport.length}}</span>
            </template>
          </v-badge>
          <v-badge
            v-if="'total_avg' in report"
            class="ml-5 my-2"
            bordered
            color="success"
            overlap
            ><v-chip
                color="success"
                label
                outlined
            >Выговор в час по группе
            </v-chip>
            <template v-slot:badge>
              <span>{{report.total_avg}}</span>
            </template>
          </v-badge>
          <v-badge
            v-if="'total_avg' in report"
            class="ml-8 my-2"
            bordered
            color="success"
            overlap
            ><v-chip
                color="success"
                label
                outlined
            >Загрузка по группе в процентах
            </v-chip>
            <template v-slot:badge>
              <span>{{report.total_rebuke}}%</span>
            </template>
          </v-badge>
          <v-badge
            v-if="'total_avg' in report"
            class="ml-8 my-2"
            bordered
            color="success"
            overlap
            ><v-chip
                color="success"
                label
                outlined
            >
              <v-icon small>mdi-sigma</v-icon>по времени разговора
            </v-chip>
            <template v-slot:badge>
              <span>{{Math.round(report.total_talk_in_seconds / 60)}}м.</span>
            </template>
          </v-badge>
          <v-badge
            v-if="'total_avg' in report"
            class="ml-10 my-2"
            bordered
            color="success"
            overlap
            ><v-chip
                color="success"
                label
                outlined
            >
              <v-icon small>mdi-sigma</v-icon>по времени работы
            </v-chip>
            <template v-slot:badge>
              <span>{{Math.round(report.total_time_in_seconds / 3600)}}ч.</span>
            </template>
          </v-badge>
          <v-badge
            v-if="'total_avg' in report && report.prediction_talk_in_seconds !== null"
            class="ml-8 my-2"
            bordered
            color="success"
            overlap
            ><v-chip
                color="success"
                label
                outlined
            >
              Прогноз минут
            </v-chip>
            <template v-slot:badge>
              <span>{{Math.round(report.prediction_talk_in_seconds / 60)}}м.</span>
            </template>
          </v-badge>
          <v-badge
            v-if="'total_avg' in report"
            class="ml-8 my-2"
            bordered
            color="success"
            overlap
            ><v-chip
                color="success"
                label
                outlined
            >
              Средний КЛН
            </v-chip>
            <template v-slot:badge>
              <span>{{report.avg_kln}}</span>
            </template>
          </v-badge>
          <v-badge
            v-if="'total_avg' in report"
            class="ml-8 my-2"
            bordered
            color="success"
            overlap
            ><v-chip
                color="success"
                label
                outlined
            >
              Кол-во офиц. претензий
            </v-chip>
            <template v-slot:badge>
              <span>{{report.count_customer_complaint}}</span>
            </template>
          </v-badge>
          <v-spacer />

          <!-- info -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                color="info"
              >mdi-information-outline</v-icon>
            </template>
            <ul style="list-style: none;padding: 0;">
              <li> <v-icon color="#B71C1C">mdi-palette</v-icon> Тёмно-красный -  время сессии и длительность вызовов рассчитаны автоматически системой, но не были подтверждены РГ.</li>
              <li> <v-icon color="#F44336">mdi-palette</v-icon> Красный - расчёт по данному сотруднику в этот день произведён не был.  </li>
              <li> <v-icon color="#4CAF50">mdi-palette</v-icon> Зелёный - время сессии и длительность вызовов рассчитаны автоматически системой и было подтверждено РГ. </li>
              <li> <v-icon color="#2196F3">mdi-palette</v-icon> Синий - время сессии и/или длительность вызовов  было заполнено вручную.</li>
              <li> <v-icon color="#9e9e9e">mdi-palette</v-icon> Серый - время сессии и длительность вызовов при расчёте оказались равны нулю или были выставлены в ноль РГ. <br>(Считаем что в этот день оператор не работал. )</li>
              <li> <v-icon color="#2f2f2f">mdi-palette</v-icon> Тёмно-серый - если стоит знак <v-icon>mdi-account-cancel</v-icon> оператор в этот день либо ещё не принят на работу либо уже уволен, <br> во всех остальных случаях клетка показывает актуальные данные за этот день по выбранному оператору. <br> Возможность подтвердить занятость, или внести какие либо изменения отсутствует.</li>
            </ul>
          </v-tooltip>

        </v-row>
      </v-container>

      <div
        v-if="'total_avg' in report"
        class="report-employment-table mt-5 v-data-table-off-overflow"
        style="max-height: calc(100vh - 87px);overflow: auto;"
      >
        <v-data-table
          :headers="headers"
          :items="actualReport"
          loading-text="Загрузка..."
          no-data-text="Ничего нет"
          hide-default-footer
          :expanded.sync="expanded"
          item-key="id"
          dense
          disable-pagination
          fixed-header
        >
          <template #[`header.agent`]="{ header }" >
            <div class="w-100 h-100 cursor-pointer header-cell" @click="sortByName">{{header.text}}</div>
          </template>
          <template #[`header.sip`]="{ header }" >
            <div class="w-100 h-100 cursor-pointer header-cell" @click="sortBySip">{{header.text}}</div>
          </template>
          <template #[`header.hoursSum`]="{ header }" >
            <div class="w-100 h-100 cursor-pointer header-cell" @click="sortBySum">{{header.text}}</div>
          </template>
          <template v-for="(day, index) in report.items[0].days" #[`header.day${index+1}`]="{ header }" >
            <div :key="`day_header_${index + 1}`" class="w-100 h-100 cursor-pointer header-cell" @click="sortByDay(day, index)">{{header.text}}</div>
          </template>

          <template #[`item.agent`]="{ item }" >
            <v-sheet
              :color="item.color"
              height="100%"
              class="name-cell name"
              :title="item.name"
            >
              <span class="sliced-name">{{item.name.match(/.+(?=\[)/)[0].trim()}}</span>
            </v-sheet>
          </template>
          <template #[`item.sip`]="{ item }" >
            <span class="mr-1">{{item.sip}}</span>
          </template>
          <template #[`item.hoursSum`]="{ item }">
            <span>{{item.sum[btnExplain]}}{{btnExplain === 'rebuke'  ? '%' : ''}}</span>
          </template>
          <!-- Ячейки дней -->
          <template v-for="(day, index) in report.items[0].cells" #[`item.day${index+1}`]="{ item }">
            <!-- Общая обёртка ячейки -->
            <v-sheet
              :key="`day_item_${index}_${item.id}`"
              :color="item.cells[index].color"
              :style="{ color: getTextColorByBg(item.cells[index].color) }"
              height="100%"
              width="100%"
              class="cursor-pointer position-relative"
              @click="handleCellClick({
                event: $event,
                item,
                day,
                schedule: item.cells[index].schedule,
                onClick: item.cells[index].on_click_main
              })"
              @contextmenu="handleCellClick({
                event: $event,
                item,
                day,
                schedule: item.cells[index].schedule,
                onClick: item.cells[index].on_click_additional
              })"
            >
              <!-- content = employment -->
              <v-tooltip
                v-if="item.cells[index].cell_content === 'employment'"
                :disabled="!item.cells[index].schedule || !(item.cells[index].schedule.hint || item.cells[index].schedule.comment)"
                bottom
              >
                <template #activator="{ on }">
                  <div v-on="on" style="width: 100%;height: 100%;white-space: nowrap;" class="name-cell">
                    {{ item.cells[index].employment[btnExplain] }}{{ btnExplain === 'rebuke' && item.cells[index].employment[btnExplain]? '%' : '' }}
                  </div>
                </template>
                <template v-if="item.cells[index].schedule">
                  <p v-if="item.cells[index].schedule.hint" class="mb-0">{{ item.cells[index].schedule.hint }}</p>
                  <p v-if="item.cells[index].schedule.comment" class="ma-0">Комментарий: {{ item.cells[index].schedule.comment }}</p>
                </template>
              </v-tooltip>

              <!-- content = schedule -->
              <div v-else-if="item.cells[index].cell_content === 'schedule'" style="width: 100%;height: 100%;">
                <v-tooltip
                  v-if="item.cells[index].schedule && item.cells[index].schedule.hint"
                  :key="`day_item_future_${index}_${item.id}`"
                  bottom
                >
                  <template #activator="{ on }">
                    <div v-on="on" style="width: 100%;height: 100%;white-space: nowrap;" class="name-cell"
                    >{{ item.cells[index].schedule.title }}</div>
                  </template>
                  <p v-if="item.cells[index].schedule.hint" class="mb-0">{{ item.cells[index].schedule.hint }}</p>
                  <p v-if="item.cells[index].schedule.from_time" class="ma-0">{{ item.cells[index].schedule.from_time }} - {{ item.cells[index].schedule.to_time }}</p>
                  <p v-if="item.cells[index].schedule.comment" class="ma-0">Комментарий: {{ item.cells[index].schedule.comment }}</p>
                </v-tooltip>
                <div
                  v-else-if="item.cells[index].schedule"
                  :key="`day_item_future_${index}_${item.id}`"
                  style="width: 100%;height: 100%;white-space: nowrap;"
                  class="name-cell"
                >{{ item.cells[index].schedule.title }}</div>
              </div>

              <!-- content = void -->
              <div v-else-if="item.cells[index].cell_content === 'void'"
                style="width: 100%;height: 100%;"
              ></div>

              <!-- content = unemployed -->
              <div v-else-if="item.cells[index].cell_content === 'unemployed'"
                style="width: 100%;height: 100%;"
                class="name-cell"
              >
                <v-icon small dark>mdi-account-cancel</v-icon>
              </div>

              <span
                v-if="item.cells[index].schedule && item.cells[index].schedule.comment"
                class="cell_has_comment"
              ></span>

            </v-sheet>
          </template>

          <!-- Actions -->
          <template #item.actions="{ item }">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-on="on" v-bind="attrs" icon :disabled="scheduleModal.disabled" @click="openScheduleModal(item)">
                  <v-icon dense>mdi-calendar</v-icon>
                </v-btn>
              </template>
              <span>Выбрать и добавить график</span>
            </v-tooltip>
          </template>


          <!-- Раскрывашка -->
          <template #expanded-item="{ headers, item }">
            <td
              v-if="Array.isArray(expandReport.history)"
              :colspan="headers.length"
              class="py-3"
            >
              <v-row>
                <v-col cols="12">
                  <h3 class="text-center my-3" style="width:100%;position: relative;">
                    {{chosenDate}}
                    <v-icon class="close-tab" @click="closeTab">mdi-close-thick</v-icon>
                  </h3>
                </v-col>
              </v-row>
              <v-row class="pt-2">
                <v-col cols="12">
                  <v-form v-if="!isToday(chosenDate) && resultLoaded">
                    <!-- Заполнение данных -->
                    <v-row dense>
                      <!-- Время Работы -->
                      <v-col cols="12" md="6" lg="5" class="pa-1">
                        <div class="expand-blocks pa-2">
                          <h3 class="text-center">Время Работы</h3>
                          <v-list>
                            <v-list-item>
                              <v-list-item-content
                                @click="pasteAuto('work')"
                                class="autocalc-block"
                              >
                                Посчитано автоматически {{secToFormat(timeline.result.diff_in_seconds)}}
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-tooltip bottom>
                                  <template #activator="{ on }">
                                    <div class="time-inputs" v-on="on">
                                      <v-text-field
                                        v-model="workTimeHand.time.hour"
                                        label="Часы"
                                        hide-details="auto"
                                        dense
                                      ></v-text-field>
                                      <v-text-field
                                        v-model="workTimeHand.time.minute"
                                        label="Минуты"
                                        hide-details="auto"
                                        dense
                                      ></v-text-field>
                                      <v-text-field
                                        v-model="workTimeHand.time.second"
                                        label="Секунды"
                                        hide-details="auto"
                                        dense
                                      ></v-text-field>
                                      <span>{{formatTime('time')}}</span>
                                    </div>
                                  </template>
                                  <span>
                                    Время можно вводить с точкой. <br>
                                    Например 1.5 часа = 01:30:00.
                                  </span>
                                </v-tooltip>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </div>
                      </v-col>
                      <!-- Время разговора -->
                      <v-col cols="12" md="6" lg="5" class="pa-1">
                        <div class="expand-blocks pa-2">
                          <h3 class="text-center">Время разговора</h3>
                          <v-list>
                            <v-list-item>
                              <v-list-item-content
                                @click="pasteAuto('talk')"
                                class="autocalc-block"
                              >
                                Посчитано автоматически {{utils.fixedNum(timeline.result.sum_calls_in_seconds / 60)}}мин.
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-text-field
                                  v-model="workTimeHand.talk.minute"
                                  label="Минуты"
                                  hide-details="auto"
                                  dense
                                ></v-text-field>
                                <v-text-field
                                  v-model="workTimeHand.talk.second"
                                  label="Секунды"
                                  hide-details="auto"
                                  dense
                                  class="ml-2"
                                ></v-text-field>
                            </v-list-item>
                          </v-list>
                        </div>
                      </v-col>
                      <!-- Загрузка -->
                      <v-col cols="12" md="6" lg="2" class="pa-1">
                        <div class="expand-blocks pa-2">
                          <h3 class="text-center">Загрузка</h3>
                          <p class="rebuke-value text-center">{{calcRebuke()}}%</p>
                        </div>
                      </v-col>
                    </v-row>
                    <!-- Заполнение коммента и кнопки отправки -->
                    <v-row dense>
                      <v-col cols="12" md="7" lg="7" class="pa-1">
                        <v-text-field
                          v-model="timeTalkForm.comment"
                          label="Комментарий"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="5" lg="5" class="pa-1 text-end mt-auto">
                        <v-btn color="info" dark class="mr-1" @click="calculateEmployment(item.id)">Рассчитать онлайн</v-btn>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="info"
                              dark
                              v-bind="attrs"
                              v-on="on"
                              class="mr-1"
                              @click="addWeekend"
                            >
                              <v-icon>mdi-glass-cocktail</v-icon>
                            </v-btn>
                          </template>
                          <span>Не работал</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="red"
                              dark
                              v-bind="attrs"
                              v-on="on"
                              class="mr-1"
                              @click="delRecord"
                            >
                              <v-icon>mdi-close-thick</v-icon>
                            </v-btn>
                          </template>
                          <span>Сброс</span>
                        </v-tooltip>
                        <v-btn
                          v-if="acceptDisable"
                          :disabled="acceptDisable"
                        >
                          введите комментарий
                        </v-btn>
                        <v-btn
                          v-else
                          :disabled="acceptDisable"
                          color="success"
                          @click="addRecord"
                        >
                          Подтвердить
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
              <!-- История / Лимиты -->
              <v-row
                v-if="!isToday(chosenDate) && resultLoaded"
                dense
                class="pt-12 report-employment-table-comments"
              >
                <v-col cols="12">

                  <v-tabs
                    v-model="historyTab"
                    color="blue"
                  >
                    <v-tab>
                      История
                    </v-tab>
                    <v-tab>
                      <v-icon
                        v-if="limitsTable.some(l => l.is_over)"
                        color="red"
                        class="mr-2"
                      >mdi-space-invaders</v-icon>
                      Лимиты
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="historyTab" grow>
                    <v-tab-item>
                      <v-card class="mt-2">

                        <v-data-table
                          :headers="expandHeaders"
                          :items="expandReport.history"
                          loading-text="Загрузка..."
                          no-data-text="Ничего нет"
                          hide-default-footer
                        >
                          <template #top>
                            <h3>История</h3>
                          </template>
                          <template #[`item.time.fill_type`]="{item}">
                            {{translateHistory[item.time.fill_type]}}
                          </template>
                          <template #[`item.talk.fill_type`]="{item}">
                            {{translateHistory[item.talk.fill_type]}}
                          </template>
                        </v-data-table>

                      </v-card>
                    </v-tab-item>

                    <v-tab-item>
                      <v-card class="mt-2">
                        <v-row>
                          <v-col md="6">
                            <v-data-table
                              :headers="limitsHeader"
                              :items="limitsTable"
                              :items-per-page="-1"
                              sort-by="is_over"
                              :sort-desc="true"
                              dense
                              loading-text="Загрузка..."
                              no-data-text="Ничего нет"
                              hide-default-footer
                            >
                              <template #item="{ item }">
                                <tr
                                  :style="{
                                    backgroundColor: item.is_over ? 'hsla(4.1, 89.6%, 58.4%, 0.13)' : 'initial',
                                  }"
                                >
                                  <td>{{ item.group }}</td>
                                  <td>{{ item.title }}</td>
                                  <td>{{ item.formula }}</td>
                                </tr>
                              </template>
                            </v-data-table>
                            <v-btn
                              v-if="limitsTable.length !== fullLimitsTable.length"
                              @click="limitsTable = fullLimitsTable"
                              color="info"
                              class="mt-2"
                            >Показать остальные</v-btn>
                          </v-col>
                        </v-row>

                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>

                </v-col>
              </v-row>

              <!-- Таймлайны -->
              <v-row class="pt-5">
                <v-col cols="12">
                  <v-tabs
                    v-model="chartTab"
                    color="blue"
                  >
                    <v-tab>
                      Таймлайн
                    </v-tab>
                    <v-tab>
                      Сессии
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="chartTab" grow>
                    <v-tab-item>
                      <v-card>
                        <v-row>
                          <v-col cols="11" v-if="timelineSum">
                            <v-badge
                              v-for="(sum, value) in timelineSum"
                              :key="`${value}_${sum}`"
                              class="mt-5 ml-4"
                              bordered
                              color="info"
                              overlap
                            >
                              <v-chip
                                color="info"
                                label
                                outlined
                                @click="copyToMouse(sum)"
                              >{{ value }}</v-chip>
                              <template v-slot:badge>
                                <span>{{ sum }}</span>
                              </template>
                            </v-badge>
                          </v-col>
                          <v-col align-self="end">
                            <!-- info -->
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="info"
                                  class="mt-3"
                                >mdi-information-outline</v-icon>
                              </template>
                              <p>Результативное время сессии считается сверху вниз.<br> Цвета означают математическую операцию.</p>
                              <ul style="list-style: none;padding: 0;">
                                <li> <v-icon color="#28A745">mdi-palette</v-icon> Зелёный - время прибавляем</li>
                                <li> <v-icon color="#2196F3">mdi-palette</v-icon> Синий - время вычитаем. </li>
                                <li> <v-icon color="#9820f3">mdi-palette</v-icon> Фиолетовый - результат после выполнения всех математических операций. </li>
                              </ul>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <timeline-charts :data="chartPayload" sum/>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item>
                      <v-card>
                        <v-row>
                          <v-col cols="11"></v-col>
                          <v-col align-self="end">
                            <!-- info -->
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="info"
                                  class="mt-3"
                                >mdi-information-outline</v-icon>
                              </template>
                              <ul style="list-style: none;padding: 0;">
                                <li> <v-icon color="#1B5E20">mdi-palette</v-icon> Тёмно-зелёный - не активные сессии с приоритетом 1 </li>
                                <li> <v-icon color="#66BB6A">mdi-palette</v-icon> Зелёный - не активные сессии с приоритетом 2 </li>
                                <li> <v-icon color="#C8E6C9">mdi-palette</v-icon> Светло зелёный - не активные сессии с приоритетом 3 </li>
                                <li> <v-icon color="#F57F17">mdi-palette</v-icon> Тёмно-жёлтый - активные сессии с приоритетом 1 </li>
                                <li> <v-icon color="#FDD835">mdi-palette</v-icon> Жёлтый - активные сессии с приоритетом 2 </li>
                                <li> <v-icon color="#FFF9C4">mdi-palette</v-icon> Светло-жёлтый- активные сессии с приоритетом 3 </li>
                              </ul>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <timeline-charts-queue :data="cahrtQueuePayload"/>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
              </v-row>
            </td>
          </template>
        </v-data-table>
      </div>
    </v-card>


    <!-- Меню смен -->
    <v-menu
      v-model="menuSchedule.show"
      :position-x="menuSchedule.x"
      :position-y="menuSchedule.y"
      absolute
      offset-y
      :close-on-content-click="false"
    >
      <v-list dense>
        <div
          style="dicplay: contents;"
          v-for="shift in shiftsList"
          :key="shift.name"
        >
          <v-menu v-if="shift.time_intervals.length"
            offset-x
            left
            open-on-hover
          >
            <template #activator="{ on, attrs }">
              <v-list-item
                dense
                link
                v-bind="attrs"
                v-on="on"
                style="min-height: 25px; margin: 0;"
                class="py-1"
                :style="{background: currentSchedule.shift_id === shift.id ? '#28A74555' : ''}"
              >
                <v-list-item-title>{{ shift.name }}</v-list-item-title>

                <v-list-item-action style="min-height: 25px; margin: 0;"><v-icon>mdi-menu-right</v-icon></v-list-item-action>
              </v-list-item>
            </template>

            <v-list dense>
              <v-list-item
                v-for="(interval, index) in shift.time_intervals"
                :key="index"
                dense
                link
                style="min-height: 25px; margin: 0;"
                class="py-1"
                @click="createOrUpdateSchedule(shift, interval)"
              >
                <v-list-item-title>{{ interval.from }} - {{ interval.to }}</v-list-item-title>
              </v-list-item>

            </v-list>
          </v-menu>

          <v-list-item v-else
            dense
            link
            style="min-height: 25px; margin: 0;"
            class="py-1"
            :style="{background: currentSchedule.shift_id === shift.id ? '#28A74555' : ''}"
            @click="createOrUpdateSchedule(shift)"
          >
            <v-list-item-title>{{ shift.name }}</v-list-item-title>
          </v-list-item>
        </div>

        <div v-if="currentSchedule.id">

          <v-divider class="my-1" />

          <!-- Поменять время -->
          <v-menu
            offset-x
            left
            top
            :close-on-content-click="false"
          >
            <template #activator="{ on, attrs }">
              <v-list-item
                v-bind="attrs"
                v-on="on"
                link
                dense
                style="min-height: 25px; margin: 0;"
                class="py-1"
              >
                <v-list-item-avatar size="20" style="min-height: 25px; margin: 0; margin-right: 10px;">
                  <v-icon size="20" style="min-height: 25px; margin: 0;">mdi-clock-time-four-outline</v-icon>
                </v-list-item-avatar>

                <v-list-item-content style="min-height: 25px; margin: 0; padding: 0;">
                  <v-list-item-title>Поменять время</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-card class="px-3 pt-2" min-width="250">
              <!-- Время "С"-->
              <v-menu
                ref="menuFromTime"
                v-model="menuFromTime"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="currentSchedule.from_time"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="currentSchedule.from_time"
                    label="С"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="menuFromTime"
                  v-model="currentSchedule.from_time"
                  full-width
                  format="24hr"
                  @click:minute="$refs.menuFromTime.save(currentSchedule.from_time)"
                />
              </v-menu>

              <!-- Время "По"-->
              <v-menu
                ref="menuToTime"
                v-model="menuToTime"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="currentSchedule.to_time"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="currentSchedule.to_time"
                    label="По"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="menuToTime"
                  v-model="currentSchedule.to_time"
                  full-width
                  format="24hr"
                  @click:minute="$refs.menuToTime.save(currentSchedule.to_time)"
                />
              </v-menu>

              <v-card-actions class="mt-3">
                <v-spacer />
                <v-btn
                  color="success"
                  small
                  @click="updateScheduleOption({from_time: currentSchedule.from_time, to_time: currentSchedule.to_time})"
                >Сохранить</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <!-- Цвет -->
          <v-menu
            offset-x
            left
            top
            :close-on-content-click="false"
          >
            <template #activator="{ on, attrs }">
              <v-list-item
                link
                dense
                style="min-height: 25px; margin: 0;"
                class="py-1"
                v-bind="attrs"
                v-on="on"
              >
                <v-list-item-avatar size="20" style="min-height: 25px; margin: 0; margin-right: 10px;">
                  <v-icon size="20" style="min-height: 25px; margin: 0;">mdi-palette</v-icon>
                </v-list-item-avatar>

                <v-list-item-content style="min-height: 25px; margin: 0; padding: 0;">
                  <v-list-item-title>Поменять цвет</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-card class="pa-2" min-width="250">
              <v-color-picker
                v-model="currentSchedule.color"
                :swatches="swatches"
                mode="hexa"
                dot-size="25"
                hide-canvas
                hide-inputs
                hide-sliders
                show-swatches
                swatches-max-height="200"
              />

              <v-card-actions class="mt-3">
                <v-spacer />
                <v-btn
                  color="success"
                  small
                  @click="updateScheduleOption({
                    color: currentSchedule.color.hex ?
                      currentSchedule.color.hex
                      : currentSchedule.color
                  })"
                >Сохранить</v-btn>
              </v-card-actions>
            </v-card>

          </v-menu>

          <!-- Комментарий -->
          <v-menu
            offset-x
            left
            top
            :close-on-content-click="false"
          >
            <template #activator="{ on, attrs }">
              <v-list-item
                link
                dense
                style="min-height: 25px; margin: 0;"
                class="py-1"
                v-bind="attrs"
                v-on="on"
              >
                <v-list-item-avatar size="20" style="min-height: 25px; margin: 0; margin-right: 10px;">
                  <v-icon size="20" style="min-height: 25px; margin: 0;">mdi-comment</v-icon>
                </v-list-item-avatar>

                <v-list-item-content style="min-height: 25px; margin: 0; padding: 0;">
                  <v-list-item-title>Комментарий</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-card class="pa-2" min-width="250">
              <v-textarea
                v-model="currentSchedule.comment"
                rows="1"
                auto-grow
                label="Комментарий"
                hide-details="auto"
              />

              <v-card-actions class="mt-3">
                <v-spacer />
                <v-btn color="success" small @click="updateScheduleOption({comment: currentSchedule.comment})">Сохранить</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <!-- Удаление -->
          <v-list-item
            link
            dense
            style="min-height: 25px; margin: 0;"
            class="py-1"
            @click="deleteOperatorSchedule"
          >
            <v-list-item-avatar size="20" style="min-height: 25px; margin: 0; margin-right: 10px;">
              <v-icon size="20" style="min-height: 25px; margin: 0;" color="red">mdi-trash-can</v-icon>
            </v-list-item-avatar>

            <v-list-item-content style="min-height: 25px; margin: 0; padding: 0;">
              <v-list-item-title>Удалить</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>

      </v-list>
    </v-menu>

    <!-- Модалка график -->
    <v-dialog
      v-model="scheduleModal.show"
      transition="dialog-top-transition"
      max-width="30vw"
      @click:outside="closeModalSchedule"
    >
      <v-card>
        <v-card-title>График для {{ scheduleModal.userName }}</v-card-title>

        <v-card-text>
          <v-form v-if="scheduleModal.show" ref="scheduleForm" lazy-validation v-model="formRules.valid">

            <!-- Селектор смен -->
            <ShiftsSelector v-model="scheduleModal.shift" @input="changeShiftInterval" :rules="formRules.required" />

            <!-- Время -->
            <v-select
              label="Время"
              v-model="scheduleModal.interval"
              :items="scheduleModal.intervals"
              :readonly="scheduleModal.readonlyIntervals"
              item-value="id"
              :item-text="(item) => `${item.from} - ${item.to}`"
            />

            <!-- Поменять время -->
            <v-checkbox
              v-model="scheduleModal.customTime"
              label="Поменять время"
              dense
              hide-details
              class="mt-0 mb-2"
              @change="changeCustomTime"
            />

            <v-row v-if="scheduleModal.customTime" dense>
              <v-col cols="6">
                <!-- Время "С"-->
                <v-menu
                  ref="modalFromTime"
                  v-model="scheduleModal.menuFromTime"
                  :close-on-content-click="false"
                  :return-value.sync="scheduleModal.fromTime"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="scheduleModal.fromTime"
                      label="С"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="formRules.required"
                    />
                  </template>
                  <v-time-picker
                    v-if="scheduleModal.menuFromTime"
                    v-model="scheduleModal.fromTime"
                    full-width
                    format="24hr"
                    @click:minute="$refs.modalFromTime.save(scheduleModal.fromTime)"
                  />
                </v-menu>
              </v-col>

              <v-col cols="6">
                <!-- Время "По"-->
                <v-menu
                  ref="modalToTime"
                  v-model="scheduleModal.menuToTime"
                  :close-on-content-click="false"
                  :return-value.sync="scheduleModal.toTime"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="scheduleModal.toTime"
                      label="По"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="formRules.required"
                    />
                  </template>
                  <v-time-picker
                    v-if="scheduleModal.menuToTime"
                    v-model="scheduleModal.toTime"
                    full-width
                    format="24hr"
                    @click:minute="$refs.modalToTime.save(scheduleModal.toTime)"
                  />
                </v-menu>
              </v-col>
            </v-row>

            <!-- Выбор дат -->
            <v-menu
              ref="menu"
              v-model="scheduleModal.menuDates"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-textarea
                  v-model="formatedScheduleDates"
                  label="Даты"
                  prepend-icon="mdi-calendar"
                  auto-grow
                  rows="1"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :rules="formRules.required"
                />
              </template>

              <v-date-picker
                v-model="scheduleModal.dates"
                multiple
                :min="scheduleModal.minDate"
                :max="scheduleModal.maxDate"
                :picker-date="scheduleModal.pickerDate"
                locale="ru-ru"
                :first-day-of-week="1"
              />
            </v-menu>
          </v-form>

        </v-card-text>


        <v-card-actions>
          <v-spacer />

          <v-btn color="grey" text @click="closeModalSchedule">Отмена</v-btn>

          <v-btn color="success" text @click="updateSchedule">Проставить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import moment from "moment"
import { mapActions, mapGetters } from 'vuex'
import UserSelector from '~/components/partials/selectors/UserSelector.vue'
import GroupSelector from '~/components/partials/selectors/GroupSelector.vue'
import TimelineCharts from '~/components/partials/TimelineCharts.vue'
import TimelineChartsQueue from '~/components/partials/TimelineChartsQueue.vue'
import ShiftsSelector from '~/components/partials/selectors/ShiftsSelector.vue'
import { requiredRule } from '~/plugins/rules'

export default {
  name: "OperatorsEmployment",
  components: {
    UserSelector,
    TimelineCharts,
    GroupSelector,
    TimelineChartsQueue,
    ShiftsSelector,
  },

  data() {
    return {
      date: {},
      groups: [],
      agents: [],
      actualReport: [],
      savedReport: [],
      onlyActive: false,
      hideBlocked: false,

      btnSwitch: 0,
      btnExplain: 'time',
      isTableLoading: false,
      expanded: [],
      workTimeHand: {
        time : {
          hour: '',
          minute: '',
          second: '',
        },
        talk : {
          minute: '',
          second: '',
        },
      },
      timeTalkForm: {
        date: '',
        operator_id: null,
        rebuke: null,
        time: null,
        talk: null,
        is_weekend: false,
        comment: '',
      },
      chosenDate: '',


      headers: [
        { text: 'Имя', value: 'agent', sortable: false, },
        { text: 'Сип', value: 'sip', sortable: false, },
        { text: 'Сумма в часах', value: 'hoursSum', sortable: false, class: 'hours_sum_cell', cellClass: 'hours_sum_cell'},
      ],
      expandHeaders: [
        { text: 'Имя РГ', value: 'rg_name' },
        { text: 'Дата', value: 'created_at' },
        { text: 'Время работы', value: 'time' },
        { text: 'Время разговора', value: 'talk' },
        { text: 'Комментарий', value: 'comment' },
        { text: 'Действие', value: 'action' },
      ],
      chartPayload: null,
      cahrtQueuePayload: null,
      chartTab: 0,
      historyTab: 0,

      limitsHeader: [
        { text: 'Группа', value: 'group'},
        { text: 'Имя', value: 'title'},
        { text: 'Формула', value: 'formula'},
        // { text: 'Превышен', value: 'is_over'},
      ],
      fullLimitsTable: [],
      limitsTable: [],

      expandReport: {},
      translateHistory: {
        hand: 'Вручную',
        auto: 'Автоматически',
        reset: 'Сброс',
      },

      sorting: {
        name: '',
        sip: '',
        sum: {
          talk: '',
          time: '',
          rebuke: '',
        },
        days: {},
      },

      caruselOptions: [],

      currentSchedule: {
        id: null,
        shift_id: null,
        userId: null,
        day: '',
        from_time: null,
        to_time: null,
        color: '',
        comment: '',
      },
      menuFromTime: false,
      menuToTime: false,

      menuSchedule: {
        show: false,
        x: 0,
        y: 0,
      },
      shiftsList: [],

      swatches: [
        ['#FFFF00', '#C17BA0', '#FF00FE', '#B8B9BD', '#FE9900', '#212121', ],
        ['#9C27B0', '#4A148C', '#6A1B9A', ],
        ['#673AB7', '#311B92', '#4527A0', ],
        ['#3F51B5', '#1A237E', '#283593', ],
        ['#F44336', '#B71C1C', '#C62828', ],
        ['#2196F3', '#0D47A1', '#1976D2', ],
        ['#009688', '#004D40', '#00796B', ],
        ['#4CAF50', '#1B5E20', '#388E3C', ],
        ['#FFEB3B', '#F57F17', '#FBC02D', ],
        ['#FF5722', '#BF360C', '#FF7043', ],
        ['#795548', '#3E2723', '#8D6E63', ],
        ['#000000', '#FFFFFF', '#393939', ],
        ['#FF0000', '#AA0000', ],
        ['#9E9E9E', '#424242', ],
        ['#00FF00', '#00AA00', ],
        ['#AAAA00', ],
      ],

      scheduleModal: {
        show: false,
        disabled: false,
        userId: null,
        userName: null,
        shift: null,
        dates: [],
        menuDates: false,
        minDate: null,
        maxDate: null,
        pickerDate: null,
        intervals: [],
        interval: null,
        readonlyIntervals: true,
        customTime: false,
        fromTime: null,
        toTime: null,
        menuFromTime: false,
        menuToTime: false,
      },
      formRules: {
        valid: false,
        required: requiredRule,
      },
      savedDate: null,
    }
  },

  computed: {
    ...mapGetters({
      groupsGetter: 'projects/groups',
      agentsGetter: 'projects/agents',
      resultLoaded: 'timeline/resultLoaded',
      timeline: 'timeline/timeline',
      timelineSum: 'timeline/timelineSum',

      report: 'operators/reportEmployment',
    }),

    acceptDisable() {
      let isTimeEven = this.timeline.result.sum_calls_in_seconds == this.timeTalkForm.talk &&
        this.timeline.result.diff_in_seconds == this.timeTalkForm.time

      if (isTimeEven) return false
      if (!isTimeEven && this.timeTalkForm.comment !== '') return false
      return true
    },

    isDarkTheme() {
      return this.$vuetify.theme.isDark;
    },

    calkTalkTime() {
      let res;
      let m = +this.workTimeHand.talk.minute;
      let s = +this.workTimeHand.talk.second;

      res = m * 60 + s
      return res;
    },


    payload() {
      return {
        period: this.date,
        users: this.agents
      }
    },

    formatedScheduleDates() {
      const dates = this.scheduleModal.dates
      let res = ''

      if (dates && dates.length) {
        res = dates.join(', ')
      }

      return res
    },

    showAutoFill() {
      if (!this.savedDate) return false
      let show = false

      const pickedDate = moment(this.savedDate)
      const nextMonth = moment().add(1, 'month')

      const isNextMonth = 
        pickedDate.year() === nextMonth.year() && 
        pickedDate.month() === nextMonth.month()

      if (isNextMonth && this.actualReport.length) {
        show = true
      }

      return show
    },
  },

  watch: {
    btnSwitch(val) {
      switch (val) {
        case 0:
          this.btnExplain = 'time';
          this.headers[2].text = 'Сумма в часах';
          break;
        case 1:
          this.btnExplain = 'talk';
          this.headers[2].text = 'Сумма в минутах';
          break;
        case 2:
          this.btnExplain = 'rebuke';
          this.headers[2].text = 'Среднее (%)';
          break;

        default:
          break;
      }
    },

    calkTalkTime(curr) {
      this.timeTalkForm.talk = curr;
    },

    onlyActive(val) {
      if (val) {
        if (this.actualReport.length === 0) return
        const report = this.getOnlyActive(this.actualReport)
        this.actualReport = report
      } else {
        if (this.hideBlocked) {
          this.actualReport = this.getOnlyUnblocked(this.savedReport)
        } else {
          this.actualReport = this.savedReport
        }
      }
    },

    hideBlocked(val) {
      if (val) {
        if (this.actualReport.length === 0) return
        const report = this.getOnlyUnblocked(this.actualReport)
        this.actualReport = report
      } else {
        if (this.onlyActive) {
          this.actualReport = this.getOnlyActive(this.savedReport)
        } else {
          this.actualReport = this.savedReport
        }
      }
    },
  },

  methods: {
    ...mapActions({
      setLoading: 'shared/setLoading',
      loadEmploymentReport: 'operators/loadEmploymentReport',
      getEmploymentInfo: 'operators/getEmploymentInfo',
      addEmploymentInfo: 'operators/addEmploymentInfo',
      deleteEmploymentInfo: 'operators/deleteEmploymentInfo',
      createOperatorSchedule: 'operators/createOperatorSchedule',
      updateOperatorSchedule: 'operators/updateOperatorSchedule',
      destroyOperatorSchedule: 'operators/destroyOperatorSchedule',
      massUpdateOperatorSchedule: 'operators/massUpdateOperatorSchedule',
      autoFillEmployment: 'operators/autoFillEmployment',
      recalculateEmployment: 'operators/recalculateEmployment',
      setSuccess: 'shared/setSuccess',
      setError: 'shared/setError',
      getShifts: 'shared/getShifts',
      resetAllState: 'resetAllState',
    }),

    getDate(data) {
      this.date = [
        moment().set('month', data).startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        moment().set('month', data).endOf('month').format('YYYY-MM-DD HH:mm:ss')
      ]
    },

    getOnlyUnblocked(items) {
      return items.filter(user => !user.isBlocked)
    },
    getOnlyActive(items) {
      return items.filter(user => !user.unActive)
    },

    fillAgents(operators) {
      this.agents = operators;
    },

    fillHeaders() {
      this.headers.splice(3)
      this.report.items[0].cells.map((day, index) => {
        let dow = moment(day.date).day()
        let classCss = ''
        if (dow === 0 || dow === 6) classCss = 'weekend_cell'
        if (dow === 6) classCss += ' sunday_cell'
        if (moment().format('Y-M-D') === moment(day.date).format('Y-M-D')) classCss = 'today_cell'

        this.headers.push({
          text: index + 1,
          value: `day${index + 1}`,
          align: 'center',
          sortable: false,
          class: classCss,
        })
      })

      this.headers.push({
          text: '',
          value: 'actions',
          align: 'left',
          sortable: false,
        }
      )
    },

    async changeExpand(item, day) {
      if (this.expanded[0]?.id === item.id && this.chosenDate === day.date) {
        this.expanded = [];
        return
      } else {
        this.expanded = [];
        this.expanded.push(item);
      }
      this.expandReport = {};
      this.chosenDate = day.date;
      this.chartTab = 0;
      this.historyTab = 0;
      this.resetTime();

      this.timeTalkForm.operator_id = item.id;
      this.timeTalkForm.date = day.date;
      this.timeTalkForm.comment = '';

      this.fullLimitsTable = [];
      this.limitsTable = [];

      this.isTableLoading = true;

      this.expandReport = await this.getEmploymentInfo({
        user_id: item.id,
        date: day.date
      })
      if (!this.expandReport) this.expandReport = {};
      else {
        let hW, mW, sW, mT, sT;
        this.expandReport.time ? hW = Math.trunc(this.expandReport.time / 3600) : hW ='0';
        this.expandReport.time ? mW = Math.trunc(this.expandReport.time % 3600 / 60) : mW = '0';
        this.expandReport.time ? sW = Math.trunc(this.expandReport.time % 60) : sW = '0';

        this.expandReport.talk ? mT = Math.trunc(this.expandReport.talk / 60) : mT = '0';
        this.expandReport.talk ? sT = Math.trunc(this.expandReport.talk % 60) : sT = '0';

        this.workTimeHand.time.hour = hW;
        this.workTimeHand.time.minute = mW;
        this.workTimeHand.time.second = sW;

        this.workTimeHand.talk.minute = mT;
        this.workTimeHand.talk.second = sT;

        // Таблица лимитов
        if (this.expandReport?.limits?.length > 0) {
          this.expandReport.limits.forEach(limit => {

            limit.properties.forEach(prop => {
              let item = {
                group: limit.name,
                title: prop.title,
                is_over: prop.is_over,
                formula: `${prop.used} ${prop.comparison_method} ${prop.value} (${prop.unit_measurement})`
              }

              this.fullLimitsTable.push(item)
              if (item.is_over) this.limitsTable.push(item)
            })
          })
        }

      }
      this.isTableLoading = false;

      // APEX
      let dates = [
        moment(`${day.date} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
        moment(`${day.date} 23:59:59`).format('YYYY-MM-DD HH:mm:ss'),
      ]

      this.chartPayload = {
        agent: item.sip,
        period: dates,
      }

      this.cahrtQueuePayload = {
        user: item.id,
        period: dates,
      }
    },

    closeTab() {
      this.resetTime();
      this.expanded = [];
    },

    isInteractDay(day) {
      let today = moment().startOf('day').unix();
      let selectDay = moment(day.date).startOf('day').unix();
      let isInteract = today > selectDay && day.was_active;
      return isInteract
    },

    isPast(day) {
      let today = moment().startOf('day').unix();
      let selectDay = moment(day.date).startOf('day').unix();
      return today >= selectDay
    },

    isToday(day) {
      let date = day.date ? day.date : day;
      let today = moment().startOf('day').unix();
      let selectDay = moment(date).startOf('day').unix();
      return today === selectDay
    },

    pasteAuto(type) {
      let talkTime = Math.round(this.timeline.result.sum_calls_in_seconds)
      switch (type) {
        case 'work':
          this.workTimeHand.time.hour = Math.trunc(this.timeline.result.diff_in_seconds / 3600);
          this.workTimeHand.time.minute = Math.trunc(this.timeline.result.diff_in_seconds % 3600 / 60);
          this.workTimeHand.time.second = Math.trunc(this.timeline.result.diff_in_seconds % 60);
          break;
        case 'talk':
          this.workTimeHand.talk.minute = Math.trunc(talkTime / 60);
          this.workTimeHand.talk.second = Math.trunc(talkTime % 60);
          break;
        default:
          break;
      }
    },

    calcRebuke() {
      let res = (this.timeTalkForm.talk / this.timeTalkForm.time) * 100;
      if (!res) res = (this.expandReport.talk / this.expandReport.time) * 100;
      return Math.round(res) || 0
    },

    resetTime() {
      this.timeTalkForm.time = 0;
      this.timeTalkForm.talk = 0;
      this.workTimeHand.time.hour = '';
      this.workTimeHand.time.minute = '';
      this.workTimeHand.time.second = '';
    },

    secToFormat(seconds) {
      return moment.utc(seconds * 1000).format('HH:mm:ss');
    },

    formatTime(type) {
      let seconds = 0;
      let hour = 0;
      let minute = 0;
      let second = 0;
      if (this.workTimeHand[type].hour) seconds += +this.workTimeHand[type].hour * 3600;
      if (this.workTimeHand[type].minute) seconds += +this.workTimeHand[type].minute * 60;
      if (this.workTimeHand[type].second) seconds += +this.workTimeHand[type].second;

      if (seconds >= 3600) hour = Math.floor(seconds / 3600);
      if (seconds >= 60) minute = Math.floor(seconds % 3600 / 60);
      second = Math.floor(seconds % 60);

      this.timeTalkForm[type] = seconds;

      return `${leadingZero(hour)}:${leadingZero(minute)}:${leadingZero(second)}`

      function leadingZero(n) {
        return n < 10 ? `0${n}` : n
      }
    },

    addRecord() {
      this.timeTalkForm.rebuke = this.calcRebuke();
      this.timeTalkForm.is_weekend = false;
      this.addEmploymentInfo(this.timeTalkForm);
    },

    addWeekend() {
      this.timeTalkForm.rebuke = 0;
      this.timeTalkForm.time = 0;
      this.timeTalkForm.talk = 0;
      this.timeTalkForm.is_weekend = true;
      this.addEmploymentInfo(this.timeTalkForm);
    },

    delRecord() {
      this.deleteEmploymentInfo(this.expandReport.id);
    },

    sortByToday(report) {
      let today = moment().format('YYYY-MM-DD')

      report.sort((prev, curr) => {
        let prevInfo = prev.days.find(day => day.date === today).rebuke;
        let currInfo = curr.days.find(day => day.date === today).rebuke;

        if (prevInfo === null) prevInfo = -2;
        if (currInfo === null) currInfo = -2;

        if (currInfo > prevInfo) return 1
        if (currInfo < prevInfo) return -1
        return 0
      })

      return report
    },

    sortByName() {
      this.sorting.name === 'asc'
        ? this.sorting.name = 'desk'
        : this.sorting.name = 'asc'

      switch (this.sorting.name) {
        case 'asc':
          this.actualReport.sort((a, b) => {
            let res = 0
            if (a.name > b.name) res = 1
            if (a.name < b.name) res = -1
            return res
          })
          break;
        case 'desk':
          this.actualReport.sort((a, b) => {
            let res = 0
            if (a.name > b.name) res = -1
            if (a.name < b.name) res = 1
            return res
          })
          break;
      }
    },

    sortBySip() {
      this.sorting.sip === 'asc'
        ? this.sorting.sip = 'desk'
        : this.sorting.sip = 'asc'

      switch (this.sorting.sip) {
        case 'asc':
          this.actualReport.sort((a, b) => {
            let res = 0
            if (a.sip > b.sip) res = 1
            if (a.sip < b.sip) res = -1
            return res
          })
          break;
        case 'desk':
          this.actualReport.sort((a, b) => {
            let res = 0
            if (a.sip > b.sip) res = -1
            if (a.sip < b.sip) res = 1
            return res
          })
          break;
      }
    },

    sortBySum() {
      this.sorting.sum[this.btnExplain] === 'desk'
        ? this.sorting.sum[this.btnExplain] = 'asc'
        : this.sorting.sum[this.btnExplain] = 'desk'

      switch (this.sorting.sum[this.btnExplain]) {
        case 'asc':
          this.actualReport.sort((a, b) => {
            let res = 0
            if (a.sum[this.btnExplain] > b.sum[this.btnExplain]) res = 1
            if (a.sum[this.btnExplain] < b.sum[this.btnExplain]) res = -1
            return res
          })
          break;
        case 'desk':
          this.actualReport.sort((a, b) => {
            let res = 0
            if (a.sum[this.btnExplain] > b.sum[this.btnExplain]) res = -1
            if (a.sum[this.btnExplain] < b.sum[this.btnExplain]) res = 1
            return res
          })
          break;
      }

    },

    sortByDay(day, index) {
      if (moment(day.date) > moment()) return
      if (!this.sorting.days[index])
        this.sorting.days[index] = {[this.btnExplain]: ''}

      this.sorting.days[index][this.btnExplain] === 'desk'
        ? this.sorting.days[index][this.btnExplain] = 'asc'
        : this.sorting.days[index][this.btnExplain] = 'desk'

      switch (this.sorting.days[index][this.btnExplain]) {
        case 'asc':
          this.actualReport.sort((a, b) => {
            let prevInfo = a.days[index][this.btnExplain];
            let currInfo = b.days[index][this.btnExplain];

            if (prevInfo === null) prevInfo = -2;
            if (currInfo === null) currInfo = -2;

            if (currInfo > prevInfo) return -1
            if (currInfo < prevInfo) return 1
            return 0
          })

          break;
        case 'desk':
          this.actualReport.sort((a, b) => {
            let prevInfo = a.days[index][this.btnExplain];
            let currInfo = b.days[index][this.btnExplain];

            if (prevInfo === null) prevInfo = -2;
            if (currInfo === null) currInfo = -2;

            if (currInfo > prevInfo) return 1
            if (currInfo < prevInfo) return -1
            return 0
          })

          break;
      }
    },

    isOverLimit(items) {
      return items.some(p => p.is_over)
    },

    copyToMouse(data) {
      window.navigator.clipboard.writeText(String(data)).then(() => {
        this.setSuccess({message: 'Скопировано в буфер'});
      }, (err) => {
        this.setError({message: err});
      })
    },

    fillCaruselOptions() {
      const monthes = [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
      ]
      const curr = new Date().getMonth() + 1
      for (let i = 3; i >= 0; i--) {
        const opt = {
          id: curr - i,
          name: monthes.at((curr - i) % 12)
        }
        this.caruselOptions.push(opt)
      }

      this.$nextTick()
        .then(() => {
          this.$refs.month_selector.setNextVal()
          this.$refs.month_selector.setNextVal()
        })
    },

    showMenuSchedule(event, schedule, userId, day) {
      this.menuSchedule.show = false
      this.currentSchedule = { ...schedule, userId, day }
      event.preventDefault()
      this.menuSchedule.x = event.clientX
      this.menuSchedule.y = event.clientY
      setTimeout(() => {
        this.menuSchedule.show = true
      }, 10);
    },

    async createOrUpdateSchedule(shift, interval = null) {
      this.menuSchedule.show = false
      const payload = {
        userId: this.currentSchedule.userId,
        day: this.currentSchedule.day,
        shift_id: shift.id,
      }

      let responseData = null

      if (interval) {
        payload.from_time = interval.from
        payload.to_time = interval.to
        payload.color = interval.color
      }

      if (this.currentSchedule.id) {
        payload.scheduleId = this.currentSchedule.id
        responseData = await this.updateOperatorSchedule(payload)
      } else {
        responseData = await this.createOperatorSchedule(payload)
      }

      const foundRow = this.actualReport.find(item => item.id === responseData.user_id)
      const foundCell = foundRow.cells.find(cell => cell.date === responseData.day)

      foundCell.cell_content = 'schedule'
      foundCell.color = responseData.color
      foundCell.schedule = responseData

      this.$forceUpdate()
    },

    async updateScheduleOption(payload) {
      this.menuSchedule.show = false
      payload.scheduleId = this.currentSchedule.id
      payload.userId = this.currentSchedule.userId

      const responseData = await this.updateOperatorSchedule(payload)

      const foundRow = this.actualReport.find(item => item.id === responseData.user_id)
      const foundCell = foundRow.cells.find(day => day.date === responseData.day)
      foundCell.color = responseData.color
      foundCell.schedule = responseData
      this.$forceUpdate()
    },

    async deleteOperatorSchedule() {
      this.menuSchedule.show = false
      const date = this.currentSchedule.day
      const payload = {
        scheduleId: this.currentSchedule.id,
        userId: this.currentSchedule.userId,
      }

      await this.destroyOperatorSchedule(payload)

      const foundRow = this.actualReport.find(item => item.id === this.currentSchedule.userId)
      const foundCell = foundRow.cells.find(day => day.date === date)


      foundCell.cell_content = 'void'
      foundCell.color = null
      foundCell.schedule = null
      // {
      //   id: null,
      //   shift_id: null,
      //   userId: null,
      //   day: date,
      //   from_time: null,
      //   to_time: null,
      //   color: '',
      //   comment: '',
      // }

      this.$forceUpdate()
    },

    openScheduleModal(item) {
      this.scheduleModal.userId = item.id
      this.scheduleModal.userName = item.name
      this.scheduleModal.show = true
    },

    closeModalSchedule() {
      this.scheduleModal.show = false

      this.scheduleModal.userId = null
      this.scheduleModal.userName = null
      this.scheduleModal.shift = null
      this.scheduleModal.dates = []
      this.scheduleModal.menuDates = false
      this.scheduleModal.interval = null
      this.scheduleModal.intervals = []
      this.scheduleModal.readonlyIntervals = true
      this.scheduleModal.customTime = false
      this.scheduleModal.fromTime = null
      this.scheduleModal.toTime = null
      this.scheduleModal.menuFromTime = false
      this.scheduleModal.menuToTime = false
    },

    changeShiftInterval(shiftId) {
      this.scheduleModal.readonlyIntervals = true
      const foundShift = this.shiftsList.find(shift => shift.id === shiftId)

      if (!foundShift) return

      this.scheduleModal.interval = null
      this.scheduleModal.intervals = foundShift.time_intervals
      this.scheduleModal.readonlyIntervals = false
    },

    changeCustomTime(value) {
      if (value) {
        const choosenInterval = this.scheduleModal.intervals
          .find(interval => interval.id === this.scheduleModal.interval)

        this.scheduleModal.fromTime = choosenInterval ? choosenInterval.from : null
        this.scheduleModal.toTime = choosenInterval ? choosenInterval.to : null
        return
      }

      this.scheduleModal.fromTime = null
      this.scheduleModal.toTime = null
      this.scheduleModal.menuFromTime = false
      this.scheduleModal.menuToTime = false
    },

    async updateSchedule() {
      if (!this.$refs.scheduleForm.validate()) return

      const choosenInterval = this.scheduleModal.intervals.find(interval => interval.id === this.scheduleModal.interval)

      const payload = {
        userId: this.scheduleModal.userId,
        days: this.scheduleModal.dates,
        shift_id: this.scheduleModal.shift,
      }

      if (choosenInterval) {
        payload.color = choosenInterval.color
        payload.from_time = choosenInterval.from
        payload.to_time = choosenInterval.to
      }

      if (this.scheduleModal.customTime) {
        payload.from_time = this.scheduleModal.fromTime
        payload.to_time = this.scheduleModal.toTime
      }

      this.massUpdateOperatorSchedule(payload)
        .then(responseData => {
          const foundRow = this.actualReport.find(item => item.id === this.scheduleModal.userId)

          for (const item of responseData) {
            const foundCell = foundRow.cells.find(cell => cell.date === item.day)
            foundCell.cell_content = 'schedule'
            foundCell.color = item.color
            foundCell.schedule = item
          }

          this.$forceUpdate()

          this.closeModalSchedule()
        })
    },

    handleCellClick(payload) {
      // payload = {event: $event, item, day, schedule: item.cells[index].schedule, onClick: item.cells[index].on_click_main }

      if (['void', 'unemployed'].includes(payload.onClick)) return
      if (payload.onClick === 'employment') {
        this.changeExpand(payload.item, payload.day)
      }
      else if (payload.onClick === 'schedule') {
        this.showMenuSchedule(payload.event, payload.schedule, payload.item.id, payload.day.date)
      }
    },

    async fillNextMonth() {
      const payload = {
        month: moment(this.savedDate).format('YYYY-MM'),
        user_ids: this.savedReport.map(item => item.id),
      }

      await this.autoFillEmployment(payload)
      this.loadReport()
    },

    getTextColorByBg(hex) {
      if (!hex) return null
      const textColor = this.utils.getTextColorByBgColor(hex)

      return textColor
    },

    async calculateEmployment(userId) {
      const payload = {
        day: this.chosenDate,
        userId,
      }

      const data = await this.recalculateEmployment(payload)
      if (!data) return

      this.timeTalkForm.talk = null
      this.timeTalkForm.time = null
      this.expandReport.talk = data.talk
      this.expandReport.time = data.time

      let hW, mW, sW, mT, sT;
      data.time ? hW = Math.trunc(data.time / 3600) : hW ='0'
      data.time ? mW = Math.trunc(data.time % 3600 / 60) : mW = '0'
      data.time ? sW = Math.trunc(data.time % 60) : sW = '0'

      data.talk ? mT = Math.trunc(data.talk / 60) : mT = '0'
      data.talk ? sT = Math.trunc(data.talk % 60) : sT = '0'

      this.workTimeHand.time.hour = hW
      this.workTimeHand.time.minute = mW
      this.workTimeHand.time.second = sW

      this.workTimeHand.talk.minute = mT
      this.workTimeHand.talk.second = sT
    },

    async loadReport() {
      if (!this.$refs.form.validate()) return
      this.setLoading(true);
      this.onlyActive = false;
      this.resetTime();
      this.expanded = [];
      this.sort = {
        name: '',
        sip: '',
        sum: {
          talk: '',
          time: '',
          rebuke: '',
        },
        days: {},
      }

      if (moment(this.date[1]).diff(moment()) <= 0) {
        this.scheduleModal.disabled = true
      } else {
        const pickedMonth = moment(this.date[0]).get('month') // 0 - 11
        const currentMonth = moment().get('month') // 0 - 11

        if (pickedMonth === currentMonth) {
          this.scheduleModal.minDate = moment().startOf('day').format('YYYY-MM-DD')
        } else {
          this.scheduleModal.minDate = moment(this.date[0]).format('YYYY-MM-DD')
        }

        this.scheduleModal.pickerDate = moment(this.date[0]).format('YYYY-MM')
        this.scheduleModal.maxDate = moment(this.date[1]).endOf('month').format('YYYY-MM-DD')

        this.scheduleModal.disabled = false
      }

      this.savedReport = await this.loadEmploymentReport(this.payload);
      this.savedDate = this.date[0]
      for (const user of this.savedReport) {
        user.unActive = false
        user.isBlocked = false

        if (user.sum.time !== 0 || user.sum.talk !== 0) continue
        user.unActive = true

        let workAtLeastDay = false

        for (const day of user.days) {
          if (day.was_active) {
            workAtLeastDay = true
            break
          }
        }

        if (workAtLeastDay === false) user.isBlocked = true
      }
      const copyReport = JSON.parse(JSON.stringify(this.savedReport))

      if (moment().month() === moment(this.date[0]).month())
        this.actualReport = this.sortByToday(copyReport);
      else
        this.actualReport = copyReport;

      this.fillHeaders();
      this.setLoading(false);
    },

    testLog(...args) {
      console.log(...args)
    },
  },

  async mounted() {
    this.shiftsList = await this.getShifts()
    this.fillCaruselOptions()
  },

  beforeDestroy() {
    this.resetAllState();
  },
};
</script>

<style lang="scss" scoped>
.expand-blocks {
  border: 2px solid #747474;
  border-radius: 5px;
  height: 100%;

}
.close-tab {
  position: absolute;
  right: 20px;
  cursor: pointer;
  transition: color 200ms ease;

  &:hover {
    color: red;
  }
}

.rebuke-value {
  font-size: 2rem;
  font-weight: bold;
  margin-block: 1rem;
}
.name-cell {
  display: grid;
  align-items: center;
  padding-left:0.2rem;
  padding-right:0.2rem;
}
.name-cell.name {
  min-width: 120px;
  width: 100%;
}

.sliced-name {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.time-inputs {
	display: flex;
	gap: 10px;
	width: 60%;
  position: relative;
}

.autocalc-block {
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.cell_has_comment {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 0;
  height: 0;
  border-bottom: 10px solid #2196F3f0;
  border-left: 10px solid transparent;
}

.position-relative {
  position: relative;
}
</style>

<style>
/* Это звиздец.... там получется v-table внутри другой v-table, из-за этого такой извврат, потом мож придумаю как поправить.... */
.report-employment-table > div > div > table > thead > tr >th:not(:first-child),
.report-employment-table > div > div > table > tbody > tr >td:not(:first-child) {
  padding: 0 !important;
}

.report-employment-table > div > div > table > thead > tr >th:not(:first-child):not(:nth-child(2)),
.report-employment-table > div > div > table > tbody > tr >td:not(:first-child):not(:nth-child(2)) {
  width: 30px;
}
.report-employment-table > div > div > table > tbody > tr >td:not(:first-child):not(:nth-child(2)) {
  border-right: 1px solid #90909030;
}
.report-employment-table > div > div > table > tbody > tr >td:not(:first-child):not(:nth-child(2)):hover {
  filter: grayscale(0.65);
}
.report-employment-table > div > div > table > tbody > tr >td:not(:first-child):not(:nth-child(2)):active {
  filter: contrast(2);
}

.hours_sum_cell {
  max-width: max-content;
}

.weekend_cell {
  background-color: #461D2C !important;
  color: #EEEEEE !important;
}
.weekend_cell.sunday_cell {
  border-right: 1px solid #90909030;
}
.today_cell {
  background-color: #0A1183 !important;
  color: #EEEEEE !important;
}

.cursor-pointer {
  cursor: pointer;
}

.header-cell:hover {
  color: white;
}
</style>